import React from 'react';
import { Download, Code, Play } from 'lucide-react';

const steps = [
  {
    icon: Download,
    title: 'Install',
    description: 'pip install agentd-sdk',
    step: '01',
  },
  {
    icon: Code,
    title: 'Change one import',
    description: 'from agentd import query',
    step: '02',
  },
  {
    icon: Play,
    title: 'Run your agent',
    description: 'See everything',
    step: '03',
  },
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-20 px-6 bg-muted/30">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight">
            Get started in <span className="text-blue-600 dark:text-blue-400">30 seconds</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Three simple steps. No configuration required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex flex-col items-center text-center space-y-6">
                <div className="relative">
                  <div className="w-20 h-20 rounded-2xl bg-blue-500/10 border-2 border-blue-500/20 flex items-center justify-center group-hover:bg-blue-500/20 transition-all">
                    <step.icon className="h-10 w-10 text-blue-600 dark:text-blue-400" />
                  </div>
                  <div className="absolute -top-3 -right-3 w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center text-sm font-bold">
                    {step.step}
                  </div>
                </div>
                <div className="space-y-2">
                  <h3 className="text-2xl font-bold">{step.title}</h3>
                  <p className="text-muted-foreground font-mono text-sm">{step.description}</p>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-10 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-blue-500/50 to-transparent"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;